import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GET_ALL_CONTACTS,
  GET_MESSAGES,
  POST_MESSAGE,
  POST_REACTION,
  POST_RESET_UNREAD_COUNT,
} from '../../../api/wca/wca.chat.service';

export const getAllContacts = createAsyncThunk(
  'sales_support/getAllContacts',
  async (
    { metadataid, pageNo = 0, limit = 30, startDate, endDate, filterData, globalFilterValue },
    thunkAPI,
  ) => {
    try {
      const contacts = await GET_ALL_CONTACTS(
        metadataid,
        pageNo,
        limit,
        startDate,
        endDate,
        filterData,
        globalFilterValue,
      );
      return contacts;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const getAllMessages = createAsyncThunk(
  'sales_support/getAllMessages',
  async ({ metadataid, phone, lastMessageId = 0, limit = 30 }, thunkAPI) => {
    try {
      const messages = await GET_MESSAGES(metadataid, phone, lastMessageId, limit);
      return messages;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const sendMessage = createAsyncThunk(
  'sales_support/sendMessage',
  async ({ metadataid, data }, thunkAPI) => {
    try {
      const response = await POST_MESSAGE(metadataid, data);
      return response; // contains message info or server response
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const sendReaction = createAsyncThunk(
  'sales_support/sendReaction',
  async ({ metadataid, data }, thunkAPI) => {
    try {
      const response = await POST_REACTION(metadataid, data);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const resetUnreadCount = createAsyncThunk(
  'sales_support/resetUnreadCount',
  async ({ metadataid, phone }, thunkAPI) => {
    try {
      const response = await POST_RESET_UNREAD_COUNT(metadataid, phone);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);
